import { render, staticRenderFns } from "./viewNum.vue?vue&type=template&id=3641ea86&"
import script from "./viewNum.vue?vue&type=script&lang=js&"
export * from "./viewNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports